import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/desarrollo-de-fármacos")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/desarrollo-de-fármacos"),
  component: RegulatoryOffering,
});

